import React from 'react';
import moment from 'moment-timezone';
import { Price } from '../../Price';
import { AvailablePrice, Date } from './CalendarDay.styles';
import { useRoomSettings } from '@features/roomSettings';
import { IndividualRoomRateAvailability } from 'shared-types/Room';

type CalendarDayProps = {
  day: IndividualRoomRateAvailability | { date: Date; price?: undefined };
};

export const CalendarDay = ({ day }: CalendarDayProps) => {
  const { data } = useRoomSettings();
  let { hideCalendarPricing } = data?.data ?? {};
  hideCalendarPricing ??= false;

  const { price, date } = day;
  const isSameOrAfter = moment(date).add(1, 'day').isSameOrAfter();

  const showPrice = isSameOrAfter && !hideCalendarPricing;

  return (
    <>
      <Date>{moment(date).format('DD')}</Date>

      {showPrice && (
        <AvailablePrice data-class="available-day-price">
          <Price price={price} noPennies />
        </AvailablePrice>
      )}
    </>
  );
};
